var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"small-margin-bottom",staticStyle:{"display":"flex"}},[_c('div',{staticStyle:{"width":"130px"}},[_c('strong',[_vm._v(_vm._s(_vm.label))])]),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }